import React, { useMemo, useState } from "react";
import { Formik } from "formik";
import { merge } from "lodash";

import KebijakanSPMI from "../content/PengaturanKomitmenMutu/KebijakanSPMI";
import KebijakanSPMILainnya from "../content/PengaturanKomitmenMutu/KebijakanSPMILainnya";
// import TargetPerguruanTinggi from "../content/PengaturanKomitmenMutu/TargetPerguruanTinggi";

import {
  useHtmlClassService,
  setLayoutConfig,
  getInitLayoutConfig,
} from "../../../../../_metronic/layout";

import { Notice, YearSelect } from "../../../../../_metronic/_partials/controls";

const localStorageActiveTabKey = "TabsPengaturanKomitmentMutuActiveTab";

export function TabsPengaturanKomitmentMutu(params) {

  const [isLoading, setIsLoading] = useState(false);

  const htmlClassService = useHtmlClassService();

  const initialValues = useMemo(
    () =>
      merge(
        getInitLayoutConfig(),
        htmlClassService.config
      ),
    [htmlClassService.config]
  );

  return (
    <>
      <Formik
        onSubmit={(values) => {
          setIsLoading(true);
          setLayoutConfig(values);
        }}
        onReset={() => {
          setIsLoading(true);
          setLayoutConfig(getInitLayoutConfig());
        }}
      >
        {() => (
          <>
            <Notice
              svg="/media/svg/icons/Home/Building.svg"
              style={{ marginBottom: "0px", boxShadow: "none" }}
            >
              <div className="d-flex align-items-center justify-content-between w-100">
                <div>
                  <strong style={{ fontSize: "18px" }}>PENETAPAN</strong>
                  <p className="mb-0">Pengaturan tentang komitmen SPMI</p>
                </div>
                <div>
                  <YearSelect />
                </div>
              </div>
            </Notice>

            <br />

            <div className="card card-custom">
              <div className="form">
                <div className="card-body">
                  <div className="tab-content">
                      <KebijakanSPMI idSp={params.idSp} />
                      <KebijakanSPMILainnya idSp={params.idSp} />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </>
  );
}